import { render, staticRenderFns } from "./YAxis.vue?vue&type=template&id=f64cd936&"
import script from "./YAxis.vue?vue&type=script&lang=js&"
export * from "./YAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports